'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noPortalApiClient = require('hub-http/clients/noPortalApiClient');

var _noPortalApiClient2 = _interopRequireDefault(_noPortalApiClient);

var _wrapHttpClient = require('./wrapHttpClient');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _wrapHttpClient.wrapHttpClient)(_noPortalApiClient2.default);
module.exports = exports['default'];